export const SET_DATA_ROLES = 'data-governance/SET_DATA_ROLES';
export const SET_DATA_ROLES_LOADING_STATE = 'data-governance/SET_DATA_ROLES_LOADING_STATE';
export const UPDATE_DATA_ROLES = 'data-governance/UPDATE_DATA_ROLES';
export const DELETE_DATA_ROLES = 'data-governance/DELETE_DATA_ROLES';
export const BULK_UPDATE_DATA_ROLES = 'data-governance/BULK_UPDATE_DATA_ROLES';
export const BULK_DELETE_DATA_ROLES = 'data-governance/BULK_DELETE_DATA_ROLES';